import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);

export const getStripe = () => stripePromise;

// Stripe configuration
export const STRIPE_CONFIG = {
  // Currency for all payments
  currency: 'usd',
  
  // Payment method types
  paymentMethodTypes: ['card'],
  
  // Billing address collection
  billingAddressCollection: 'required',
  
  // Success and cancel URLs
  successUrl: `${window.location.origin}/dashboard?success=true`,
  cancelUrl: `${window.location.origin}/subscription?canceled=true`,
};

// Stripe price IDs mapping (you'll need to create these in your Stripe dashboard)
export const STRIPE_PRICE_IDS = {
  // Monthly plans
  'starter-monthly': 'price_1RWPWaB6Ei0NpjU6WatKiQPU',
  'pro-monthly': 'price_1RWPXbB6Ei0NpjU6KFRWi5q8',
  'build-monthly': 'price_1RWPYZB6Ei0NpjU6yD44meUg',
  
  // Annual plans - TODO: Replace with actual Stripe price IDs
  'graphics-annual': 'price_graphics_annual', // Replace with actual Stripe price ID
  'experience-annual': 'price_experience_annual', // Replace with actual Stripe price ID
  'build-annual': 'price_build_annual', // Replace with actual Stripe price ID
};

// Helper function to get Stripe price ID from plan
export const getStripePriceId = (planName: string, billingCycle: 'monthly' | 'annual'): string => {
  const key = `${planName.toLowerCase()}-${billingCycle}`;
  return STRIPE_PRICE_IDS[key as keyof typeof STRIPE_PRICE_IDS] || '';
};

// Helper function to format amount for Stripe (convert to cents)
export const formatAmountForStripe = (amount: number): number => {
  return Math.round(amount * 100);
};

// Helper function to format amount from Stripe (convert from cents)
export const formatAmountFromStripe = (amount: number): number => {
  return amount / 100;
}; 